import { v4 as uuidv4 } from 'uuid';

import { GENERAL_WIZARD_TEXT } from 'client/js/main/screens/ScreenQrCodeLinkCreator/constants/GeneralWizardText';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import type { QrCodeLinkCreatorState } from '../types';

export const INIT_STATE: WrappedReducer<QrCodeLinkCreatorState> = {
  loadingStatus: 0,
  loading: false,
  error: undefined,
  step: GENERAL_WIZARD_TEXT.step,
  defineStepVisited: false,
  analyticTagsStepVisited: false,
  redirectsStepVisited: false,
  customLinkDataStepVisited: false,
  customizeStepVisited: false,
  hasBlacklistError: false,
  id: undefined,
  title: '',
  feature: undefined,
  channel: undefined,
  campaign: undefined,
  tags: [],
  iosRedirect: 'default',
  ios: undefined,
  androidRedirect: 'default',
  android: undefined,
  isWebOnly: false,
  linkData: [{ id: uuidv4(), key: undefined, value: undefined }],
  qrSettingsId: undefined,
  qrCodeCustomization: {},
};
